import store from ".."

const uuid4 = () => {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'
  .replace(/[xy]/g, function (c) {
      const r = Math.random() * 16 | 0, 
          v = c == 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
  });
}

export default {
  state: {
    newOrder: undefined
  },
  mutations: {
    dropOrder(state) {
      state.newOrder = undefined
    },
    dropItems(state) {
      state.newOrder.items = {}
    },
    setOrderPart(state, data) {
      if (state.newOrder === undefined) {
        state.newOrder = {
          order_type: 'delivery',
          payment_type: "CARD",
          items: {}
        }
      }

      state.newOrder = {...state.newOrder, ...data}
    },
    setItems(state, item) {
      state.newOrder.items[item.line_guid] = item
    }
  },
  actions: {
    async validateOrder({ dispatch }, order) {
      return await dispatch('apiQuery', {method: '/order/validate', body: order})
    },
    async setOrderType({ commit, dispatch, getters }, order_type) {
      let orderItems =  getters.orderItems

      if (Object.keys(orderItems).length > 0) {
        var validation_results = await dispatch('validateOrder', getters.validationOrderModel(getters.orderItems, order_type))
      }

      await commit('setOrderPart', { order_type })
      return validation_results || {}
    },
    async setPaymentType({ commit}, payment_type){
      await commit('setOrderPart', {payment_type})
    },
    async setDeliveryDate({commit}, delivery_date){
      await commit('setOrderPart', { delivery_date })
    },
    async setOrderComment({ commit }, comment){
      await commit('setOrderPart', {comment})
    },
    async setGuest({ commit, dispatch }, guest) {
      await commit('setOrderPart', { guest })
      if (guest === undefined) {
        await Promise.all([
          dispatch('setPhone', undefined),
          dispatch('setAddress', undefined)
        ])
      }
    },
    async setAddress({ commit }, address) {
      await commit('setOrderPart', { address })
    },
    async setPhone({ commit }, phone) {
      await commit('setOrderPart', { phone })
    },
    async setDeliveryZone({ commit, dispatch, getters }, deliveryZone) {
      let orderItems =  getters.orderItems

      await commit('setOrderPart', {delivery_zone: deliveryZone})

      if (Object.keys(orderItems).length > 0) {
        var validation_results = await dispatch('validateOrder', getters.validationOrderModel(getters.orderItems, getters.orderType, deliveryZone.idx))
      }

      return validation_results || {}
    },
    async removePhone({ dispatch, commit }, phone) {
      let guest = await dispatch('apiQuery', {method: '/guest/phone/remove', body: phone})
      await commit('setOrderPart', { guest })
    },
    async removeAddress({ dispatch, commit }, address) {
      let guest = await dispatch('apiQuery', {method: '/guest/address/remove', body: address})
      await commit('setOrderPart', { guest })
    },
    async pushItem({ dispatch, commit, getters }, item) {
      let orderItems = getters.orderItems

      let [guid, existantLine] = Object.entries(orderItems).filter((el) => JSON.stringify({...el[1].product, modifiers: el[1].modifiers}) === JSON.stringify({...item.product, modifiers: item.modifiers}))[0] || [undefined, undefined]

      if (guid !== undefined) {
        if (existantLine.product.add_line_mode !== "almOnePortion") {
          orderItems[guid] = {...existantLine, quantity: existantLine.quantity + item.quantity}
        } else {
          orderItems[uuid4()] = item
        }
      } else {
        orderItems[uuid4()] = item
      }

      let validation_results = await dispatch('validateOrder', getters.validationOrderModel(orderItems))

      // update order items only if order validation was successful 
      await commit('setOrderPart', {
        items: orderItems
      })

      return validation_results
    },
    async changeItemQuantity({dispatch, commit, getters}, item) {
      let orderItems = getters.orderItems
      let existantLine = orderItems[item.guid]

      if (existantLine.quantity + item.quantity <= 0) {
        return await dispatch('delItem', item)
      } else {
        existantLine.quantity += item.quantity
        orderItems[item.guid] = existantLine

        let validation_results = await dispatch('validateOrder', getters.validationOrderModel(orderItems))

        await commit('setOrderPart', {items: orderItems})

        return validation_results
      }
    },
    async delItem({dispatch, commit, getters}, { guid }) {
      
      let orderItems = getters.orderItems
      delete orderItems[guid]

      if (Object.keys(orderItems).length === 0) {
        return {}
      }

      let validation_results = await dispatch('validateOrder', getters.validationOrderModel(orderItems))

      await commit('setOrderPart', {items: orderItems})

      return validation_results
    },
    async saveNewOrder({ dispatch, getters }){
      const $t = getters.localePhrase
      let orderItems = getters.orderItems

      if(Object.keys(orderItems).length === 0){
        throw new Error($t('Корзина пуста'))
      }

      return await dispatch('apiQuery', {method: '/order/new', body: getters.postOrderModel})
    }
  },
  getters: {
    hasOrderMarkup(state) {
      return state.newOrder !== undefined
    },
    orderType(state) {
      return state.newOrder?.order_type || 'delivery'
    },
    paymentType(state){
      return state.newOrder?.payment_type
    },
    deliveryTime(state){
      return state.newOrder?.delivery_time 
    },
    deliveryZone(state){
      return state.newOrder?.delivery_zone
    },
    deliveryDate(state){
      return state.newOrder?.delivery_date    
    },
    orderGuest(state) {
      return state.newOrder?.guest
    },
    orderPhone(state) {
      return state.newOrder?.phone
    },
    orderAddress(state) {
      return state.newOrder?.address
    },
    orderItems(state) {
      return state.newOrder?.items || {}
    },
    orderComment(state){
      return state.newOrder?.comment 
    },
    validationOrderModel(state, getters) {
      let guest_discount = getters.orderGuest?.discount
      return (items, order_type, delivery_zone) => { return {
        order_type: order_type || getters.orderType,
        delivery_zone: delivery_zone || getters.deliveryZone?.idx,
        content: {
          table: null,
          // discounts: null,
          discounts: guest_discount ? [{ code: guest_discount }] : null,
          items: Object.entries(items).map(([guid, el]) => {
            return {
              line_guid: guid, 
              id: el.product.id, 
              quantity: el.product.id === store.getters.config.r_keeper_references.dish_delivery ? 1 : el.quantity, 
              modifiers: el.modifiers.map(combo => {
                return {
                  id: combo.modifier.id,
                  quantity: combo.quantity,
                  modifiers: combo.modifiers?.map(modi => {
                    return {
                      id: modi.modifier.id,
                      quantity: modi.quantity
                    }
                  })
                }
              })
            }
          })
        }
      }}
    },
    postOrderModel(state, getters){
      
      let orders = getters.validationOrderModel(getters.orderItems)
      let timezone = getters.local_refs.schedule.timezone
      return {
        ...orders,
        guest: getters.orderGuest,
        phone: getters.orderPhone,
        address: getters.orderAddress,
        payment_type: getters.paymentType,
        deliver_at: getters.deliveryDate?.setZone(timezone), 
        comment: getters.orderComment,
      }
    }
  }
}